import React from 'react'
import { Box, Button, Typography } from '@mui/material'
import RowStack from 'components/atoms/container/RowStack'
import colors from 'styles/colors'
import { useTranslation } from 'react-i18next'
import { MEETINGS } from 'routes/constants'
import moment from 'moment'
import MeetingNoteTakerButton from './MeetingNoteTakerButton'
import UserMeetingTitle from './meeting/UserMeetingTitle'
import { eventTitle, eventEnded } from 'utils/eventUtils'
import StyledBreadcrumbs from 'components/atoms/container/Breadcrumbs'
import { NoteTakerDisclaimer } from './meeting/SummaryMolecules'
import { trackMeetingJoined } from 'services/amplitudeMeetingTracking'
import VideocamOutlinedIcon from '@mui/icons-material/VideocamOutlined'
import { IconContainer } from 'components/atoms/Icons'

const UserMeetingHeader = ({
  connection,
  event,
  isOwner,
  isClosed,
  hasBot,
  setHasBot,
  meetingUrl,
  setMeetingUrl,
  calendarNotConnected,
  setCalendarNotConnected
}) => {
  const { t } = useTranslation()
  const onGoingMeeting = () =>
    moment.utc().add(5, 'minutes').isAfter(moment.utc(event.startTime)) &&
    moment.utc().isBefore(moment.utc(event.endTime).add(5, 'minutes'))
  const handleJoinMeeting = () => {
    trackMeetingJoined(event, '1:1 meeting page')
    window.open(meetingUrl, '_blank')
  }
  return (
    <Box width={'100%'}>
      <StyledBreadcrumbs
        containerSx={{ paddingY: 8 }}
        crumbs={[
          {
            label: t('myTeam.meetings'),
            path: MEETINGS
          },
          {
            label: eventTitle(connection, event.startTime)
          }
        ]}
      />
      <>
        {connection && event && (
          <RowStack sx={{ paddingY: 2 }} justifyContent='space-between'>
            <UserMeetingTitle event={event} connection={connection} />
            <RowStack width='unset' spacing={4}>
              {isClosed ? (
                <Typography
                  variant='body1Small'
                  sx={{ color: colors.LightGrey400, textAlign: 'right' }}>
                  {t('myTeam.thisMeetingIsOver')}
                </Typography>
              ) : (
                <>
                  {isOwner && !eventEnded(event, 0) && (
                    <MeetingNoteTakerButton
                      event={event}
                      meetingUrl={meetingUrl}
                      setMeetingUrl={setMeetingUrl}
                      hasBot={hasBot}
                      setHasBot={setHasBot}
                      calendarNotConnected={calendarNotConnected}
                      setCalendarNotConnected={setCalendarNotConnected}
                    />
                  )}
                  {meetingUrl && onGoingMeeting() && (
                    <Button
                      size='small'
                      onClick={handleJoinMeeting}
                      startIcon={
                        <IconContainer icon={<VideocamOutlinedIcon />} />
                      }>
                      {t('myTeam.joinMeeting')}
                    </Button>
                  )}
                  {isOwner && !eventEnded(event, 0) && <NoteTakerDisclaimer />}
                </>
              )}
            </RowStack>
          </RowStack>
        )}
      </>
    </Box>
  )
}

export default UserMeetingHeader
